module.exports = __webpack_public_path__ + "static/dap_hero_mobile-d242df02f0286febffa34a6498195f9d.png";